import _ from 'lodash'
import { createMuiTheme } from '@material-ui/core/styles';
import { baseTheme } from './base'
import palette from './palette'

export const createTheme = () => {
  return createMuiTheme(_.merge({}, baseTheme, palette))
}